import { Checkbox } from "@mui/material";
import {
  CmpTypographyField,
  CmpTextField,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import moment from "moment";
export default function WmsHead({ xref, vRdxHead }) {
  return (
    <form id="WmsStockAdjustmentHead">
      <Grid
        container
        rowSpacing={{ xs: 4, sm: 0, md: 2 }}
        columnSpacing={{ xs: 0, sm: 0, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        className="align-items-center"
      >
        <Grid item xs={3} sm={2} md={2} lg={1}>
          <CmpTypographyField xcomponent={"span"} xText={"Doc.Type"} />
        </Grid>

        <Grid item xs={6} sm={10} md={4} lg={2}>
          <CmpTextField
            xref={xref}
            xtabIndex={"3"}
            xValue={vRdxHead.VocName}
            xType={"text"} // text/number/password
            xName={"DocTypeName"}
            xReadOnly={true}
            xOnChange={() => {}}
            xTextAlign="center"
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={1}>
          <CmpTypographyField xcomponent={"span"} xText={"Doc No"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={2}>
          <CmpTextField
            xTextAlign="center"
            xtabIndex={"1"}
            xValue={vRdxHead.A_VocNo}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"DocNo"}
            xReadOnly={true}
            xOnChange={() => {}}
          />
        </Grid>

        <Grid item xs={3} sm={2} md={2} lg={1}>
          <CmpTypographyField xcomponent={"span"} xText={" Loc"} />
        </Grid>
        <Grid item xs={7} sm={8} md={10} lg={2}>
          <CmpTextField
            xref={xref}
            xtabIndex={"3"}
            xValue={vRdxHead.LocName}
            xType={"text"} // text/number/password
            xName={"LocName"}
            xReadOnly={true}
            xOnChange={() => {}}
            xTextAlign="center"
          />
        </Grid>
        
        <Grid item xs={2} sm={2} md={12} lg={3}>
          
          <CmpCheckboxField
            xtabIndex={"107"}
            xChecked={vRdxHead.PA_Typ == "A"}
            xOnChange={(e) => {}}
            xDisabled={false}
            xName={"Auto"}
            xNameField={"Auto"}
          />
        </Grid>

        <Grid item xs={3} sm={2} md={2} lg={1}>
          <CmpTypographyField xcomponent={"span"} xText={"Date"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={2}>
          <CmpTextField
            xTextAlign="center"
            xtabIndex={"1"}
            xValue={moment(vRdxHead.PA_DocDt).format("DD/MM/YYYY")}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"Date"}
            xReadOnly={true}
            xOnChange={() => {}}
          />
        </Grid>

        <Grid item xs={3} sm={2} md={2} lg={1}>
          <CmpTypographyField xcomponent={"span"} xText={"Unloading Bay"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={2}>
          <CmpTextField
            xTextAlign="center"
            xtabIndex={"1"}
            xValue={vRdxHead.UBAY}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"UBAY"}
            xReadOnly={true}
            xOnChange={() => {}}
          />
        </Grid>
        <Grid item xs={3} sm={2} md={2} lg={1}>
          <CmpTypographyField xcomponent={"span"} xText={"Unloading Bay"} />
        </Grid>
        <Grid item xs={9} sm={10} md={4} lg={2}>
          <CmpTextField
            xTextAlign="center"
            xtabIndex={"1"}
            xValue={vRdxHead.UBAYName}
            xVariant={"standard"}
            xType={"text"} // text/number/password
            xName={"UBAYName"}
            xReadOnly={true}
            xOnChange={() => {}}
          />
        </Grid>
      </Grid>
    </form>
  );
}
